import { ref } from 'vue'

export const showAssociatedFilter = ref({
	asset: false,
	dataAsset: false,
	module: false,
	user: false,
})
